export default __webpack_public_path__ + "static/media/01-landscape.0f5537ba.gif";